import gql from 'graphql-tag';
import { ADDITIONAL_ACCOUNT_RELATION_FRAGMENT } from './fragments/additionalAccountViewModel.fragment';

export const SWITCH_ADDITIONAL_ACCOUNT = gql`
  mutation SwitchAccount($input: SwitchAdditionalAccountInput!) {
    additionalAccount {
      result: switchAccount(input: $input) {
        success
        error
        entity {
          ...AdditionalAccountRelationViewModel
        }
      }
    }
  }
  ${ADDITIONAL_ACCOUNT_RELATION_FRAGMENT}
`;
